module.exports = __webpack_public_path__ + "img/bcard_5.06272f15.png";